import { Plugin } from "vue";
import { useUserStore } from "~stores/User.ts";

const plugin: Plugin = {
  install: (app, options) => {
    // inject a globally available $numberFormat() method
    app.config.globalProperties.$numberFormat = (number, options) => {
      let numberToFormat = number;

      if (typeof numberToFormat === "string") {
        numberToFormat = parseFloat(numberToFormat);
      }

      const defaultOptions = {
        minDecimals: 0,
        maxDecimals: 2
      };
      const resolvedOptions = Object.assign({}, defaultOptions, options ?? {});
      const numberFormatter = Intl.NumberFormat("nl-NL", {
        minimumFractionDigits: resolvedOptions.minDecimals,
        maximumFractionDigits: resolvedOptions.maxDecimals
      });

      return numberFormatter.format(numberToFormat);
    };
  }
};

export default plugin;

declare module "vue" {
  interface ComponentCustomProperties {
    $numberFormat: (
      number: number | string,
      options?: { minDecimals?: number; maxDecimals?: number }
    ) => string;
  }
}
